// extracted by mini-css-extract-plugin
export default {"main":"CardComponent_main__PqahO","header":"CardComponent_header__BhoSx","header_text":"CardComponent_header_text__QvC0g","description":"CardComponent_description__0+HXM"};